import type React from 'react';

/** Reveal the complete focused control, including portions behind fixed player chrome. */
export function revealFocusedHotspot(
  event: React.FocusEvent<HTMLElement>,
  viewport: HTMLElement | null
) {
  const control = (event.target as HTMLElement).closest<HTMLElement>(
    'button, [role="button"]'
  );
  if (
    !control?.closest('[data-image-container], [data-image-map-anchor]') ||
    !event.currentTarget.contains(control) ||
    !control.matches(':focus-visible')
  )
    return;
  requestAnimationFrame(() => {
    if (
      !viewport?.contains(control) ||
      control.ownerDocument.activeElement !== control
    )
      return;
    const bounds = viewport.getBoundingClientRect();
    const rect = control.getBoundingClientRect();
    const visible =
      rect.left >= Math.max(0, bounds.left) &&
      rect.top >= Math.max(0, bounds.top) &&
      rect.right <= Math.min(window.innerWidth, bounds.right) &&
      rect.bottom <= Math.min(window.innerHeight, bounds.bottom);
    const clear = [
      [0.5, 0.5],
      [0.05, 0.5],
      [0.95, 0.5],
      [0.5, 0.05],
      [0.5, 0.95],
      [0.2, 0.2],
      [0.2, 0.8],
      [0.8, 0.2],
      [0.8, 0.8]
    ].every(([x, y]) =>
      control.contains(
        control.ownerDocument.elementFromPoint(
          rect.left + rect.width * x,
          rect.top + rect.height * y
        )
      )
    );
    if (!visible || !clear)
      control.scrollIntoView({ block: 'center', inline: 'center' });
  });
}
